// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/components/buttons.scss
// module id = 872
// module chunks = 0